import React from 'react';
import BottomButtonsNew from '../../shared/BottomButtonsNew/BottomButtonsNew';
import { MainLogo } from '../../constants/assets';

const Welcome = props => {
    const goToNext = () => {
        const { history } = props;
        history.push("/discover");
    };

    const goToTerms = () => {
        window.open('http://lamoderna.com.mx/promos/TyC_Web_LM_Dinamica_NavidadConLaModerna2018.pdf', "_blank");
    };

    return (
        <div className="welcome-page text-center logo-only">
            { /*<h1>En estas fiestas,</h1>*/ }
            <MainLogo customClass="welcome-logo" />
            <button className="terms" onClick={goToTerms}>Términos y condiciones</button>
            { /*
            <p>
                quiere regalarte algo<br/>
                <span className="font-sep">muy especial</span><br />
                para que sigas cocinando con amor.
            </p>
            */ }
            <BottomButtonsNew
                btn1={{
                    btnAction: goToNext,
                    customClass: 'next-button-new'
                }}
            />
        </div>
    );
};

export default Welcome;
